/**
 * Prefer runtime values from /config.js (window.*), then CRA build-time process.env.
 */
export const getRuntimeEnv = (key, fallback = "") => {
  if (typeof window !== "undefined") {
    const fromWindow = window[key];
    if (fromWindow != null && fromWindow !== "") {
      return fromWindow;
    }
  }
  const fromProcess = process.env[key];
  if (fromProcess != null && fromProcess !== "") {
    return fromProcess;
  }
  return fallback;
};

/** OD / ephemeral marker — helm sets INFRA_ENV; older path used APP_CONFIG.infraDev */
export const getInfraDev = () => {
  if (typeof window !== "undefined") {
    if (window.APP_CONFIG?.infraDev) return window.APP_CONFIG.infraDev;
    if (window.INFRA_ENV) return window.INFRA_ENV;
    if (window.INFRA_DEV) return window.INFRA_DEV;
  }
  return process.env.INFRA_DEV || process.env.INFRA_ENV || "";
};
